var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('head-new'),_c('router-view',{key:_vm.$route.path,scopedSlots:_vm._u([{key:"default",fn:function({Component} ){return [_c('transition',{attrs:{"name":"contentMove","appear":""}},[_c(Component,{tag:"component"})],1)]}}])}),_c('foot-vue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }